import { CountryCode } from '@carsys/enums/country-code'

type CurrencyData = {
  [key in CountryCode]: {
    countryName: string
    currency: string
    symbol: string
  }
}

const currencyData: CurrencyData = {
  [CountryCode.BD]: {
    countryName: 'Bangladesh',
    currency: 'BDT',
    symbol: 'Tk'
  },
  [CountryCode.BE]: {
    countryName: 'Belgium',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.BF]: {
    countryName: 'Burkina Faso',
    currency: 'XOF',
    symbol: 'CFA'
  },
  [CountryCode.BG]: {
    countryName: 'Bulgaria',
    currency: 'BGN',
    symbol: 'BGN'
  },
  [CountryCode.BA]: {
    countryName: 'Bosnia and Herzegovina',
    currency: 'BAM',
    symbol: 'KM'
  },
  [CountryCode.BB]: {
    countryName: 'Barbados',
    currency: 'BBD',
    symbol: 'BBD'
  },
  [CountryCode.WF]: {
    countryName: 'Wallis and Futuna',
    currency: 'XPF',
    symbol: 'XPF'
  },
  [CountryCode.BL]: {
    countryName: 'Saint Barthelemy',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.BM]: {
    countryName: 'Bermuda',
    currency: 'BMD',
    symbol: 'BMD'
  },
  [CountryCode.BN]: {
    countryName: 'Brunei',
    currency: 'BND',
    symbol: 'BN$'
  },
  [CountryCode.BO]: {
    countryName: 'Bolivia',
    currency: 'BOB',
    symbol: 'Bs'
  },
  [CountryCode.BH]: {
    countryName: 'Bahrain',
    currency: 'BHD',
    symbol: 'BD'
  },
  [CountryCode.BI]: {
    countryName: 'Burundi',
    currency: 'BIF',
    symbol: 'FBu'
  },
  [CountryCode.BJ]: {
    countryName: 'Benin',
    currency: 'XOF',
    symbol: 'CFA'
  },
  [CountryCode.BT]: {
    countryName: 'Bhutan',
    currency: 'BTN',
    symbol: 'BTN'
  },
  [CountryCode.JM]: {
    countryName: 'Jamaica',
    currency: 'JMD',
    symbol: 'J$'
  },
  [CountryCode.BV]: {
    countryName: 'Bouvet Island',
    currency: 'NOK',
    symbol: 'Nkr'
  },
  [CountryCode.BW]: {
    countryName: 'Botswana',
    currency: 'BWP',
    symbol: 'BWP'
  },
  [CountryCode.WS]: {
    countryName: 'Samoa',
    currency: 'WST',
    symbol: 'WST'
  },
  [CountryCode.BQ]: {
    countryName: 'Bonaire, Saint Eustatius and Saba ',
    currency: 'USD',
    symbol: '$'
  },
  [CountryCode.BR]: {
    countryName: 'Brazil',
    currency: 'BRL',
    symbol: 'R$'
  },
  [CountryCode.BS]: {
    countryName: 'Bahamas',
    currency: 'BSD',
    symbol: 'BSD'
  },
  [CountryCode.JE]: {
    countryName: 'Jersey',
    currency: 'GBP',
    symbol: '£'
  },
  [CountryCode.BY]: {
    countryName: 'Belarus',
    currency: 'BYR',
    symbol: 'BYR'
  },
  [CountryCode.BZ]: {
    countryName: 'Belize',
    currency: 'BZD',
    symbol: 'BZ$'
  },
  [CountryCode.RU]: {
    countryName: 'Russia',
    currency: 'RUB',
    symbol: 'RUB'
  },
  [CountryCode.RW]: {
    countryName: 'Rwanda',
    currency: 'RWF',
    symbol: 'RWF'
  },
  [CountryCode.RS]: {
    countryName: 'Serbia',
    currency: 'RSD',
    symbol: 'din.'
  },
  [CountryCode.TL]: {
    countryName: 'East Timor',
    currency: 'USD',
    symbol: '$'
  },
  [CountryCode.RE]: {
    countryName: 'Reunion',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.TM]: {
    countryName: 'Turkmenistan',
    currency: 'TMT',
    symbol: 'TMT'
  },
  [CountryCode.TJ]: {
    countryName: 'Tajikistan',
    currency: 'TJS',
    symbol: 'TJS'
  },
  [CountryCode.RO]: {
    countryName: 'Romania',
    currency: 'RON',
    symbol: 'RON'
  },
  [CountryCode.TK]: {
    countryName: 'Tokelau',
    currency: 'NZD',
    symbol: 'NZ$'
  },
  [CountryCode.GW]: {
    countryName: 'Guinea-Bissau',
    currency: 'XOF',
    symbol: 'CFA'
  },
  [CountryCode.GU]: {
    countryName: 'Guam',
    currency: 'USD',
    symbol: '$'
  },
  [CountryCode.GT]: {
    countryName: 'Guatemala',
    currency: 'GTQ',
    symbol: 'GTQ'
  },
  [CountryCode.GS]: {
    countryName: 'South Georgia and the South Sandwich Islands',
    currency: 'GBP',
    symbol: '£'
  },
  [CountryCode.GR]: {
    countryName: 'Greece',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.GQ]: {
    countryName: 'Equatorial Guinea',
    currency: 'XAF',
    symbol: 'FCFA'
  },
  [CountryCode.GP]: {
    countryName: 'Guadeloupe',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.JP]: {
    countryName: 'Japan',
    currency: 'JPY',
    symbol: '¥'
  },
  [CountryCode.GY]: {
    countryName: 'Guyana',
    currency: 'GYD',
    symbol: 'GYD'
  },
  [CountryCode.GG]: {
    countryName: 'Guernsey',
    currency: 'GBP',
    symbol: '£'
  },
  [CountryCode.GF]: {
    countryName: 'French Guiana',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.GE]: {
    countryName: 'Georgia',
    currency: 'GEL',
    symbol: 'GEL'
  },
  [CountryCode.GD]: {
    countryName: 'Grenada',
    currency: 'XCD',
    symbol: 'XCD'
  },
  [CountryCode.GB]: {
    countryName: 'United Kingdom',
    currency: 'GBP',
    symbol: '£'
  },
  [CountryCode.GA]: {
    countryName: 'Gabon',
    currency: 'XAF',
    symbol: 'FCFA'
  },
  [CountryCode.SV]: {
    countryName: 'El Salvador',
    currency: 'USD',
    symbol: '$'
  },
  [CountryCode.GN]: {
    countryName: 'Guinea',
    currency: 'GNF',
    symbol: 'FG'
  },
  [CountryCode.GM]: {
    countryName: 'Gambia',
    currency: 'GMD',
    symbol: 'GMD'
  },
  [CountryCode.GL]: {
    countryName: 'Greenland',
    currency: 'DKK',
    symbol: 'Dkr'
  },
  [CountryCode.GI]: {
    countryName: 'Gibraltar',
    currency: 'GIP',
    symbol: 'GIP'
  },
  [CountryCode.GH]: {
    countryName: 'Ghana',
    currency: 'GHS',
    symbol: 'GH₵'
  },
  [CountryCode.OM]: {
    countryName: 'Oman',
    currency: 'OMR',
    symbol: 'OMR'
  },
  [CountryCode.TN]: {
    countryName: 'Tunisia',
    currency: 'TND',
    symbol: 'DT'
  },
  [CountryCode.JO]: {
    countryName: 'Jordan',
    currency: 'JOD',
    symbol: 'JD'
  },
  [CountryCode.HR]: {
    countryName: 'Croatia',
    currency: 'HRK',
    symbol: 'kn'
  },
  [CountryCode.HT]: {
    countryName: 'Haiti',
    currency: 'HTG',
    symbol: 'HTG'
  },
  [CountryCode.HU]: {
    countryName: 'Hungary',
    currency: 'HUF',
    symbol: 'Ft'
  },
  [CountryCode.HK]: {
    countryName: 'Hong Kong',
    currency: 'HKD',
    symbol: 'HK$'
  },
  [CountryCode.HN]: {
    countryName: 'Honduras',
    currency: 'HNL',
    symbol: 'HNL'
  },
  [CountryCode.HM]: {
    countryName: 'Heard Island and McDonald Islands',
    currency: 'AUD',
    symbol: 'AU$'
  },
  [CountryCode.VE]: {
    countryName: 'Venezuela',
    currency: 'VEF',
    symbol: 'Bs.F.'
  },
  [CountryCode.PR]: {
    countryName: 'Puerto Rico',
    currency: 'USD',
    symbol: '$'
  },
  [CountryCode.PS]: {
    countryName: 'Palestinian Territory',
    currency: 'ILS',
    symbol: '₪'
  },
  [CountryCode.PW]: {
    countryName: 'Palau',
    currency: 'USD',
    symbol: '$'
  },
  [CountryCode.PT]: {
    countryName: 'Portugal',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.SJ]: {
    countryName: 'Svalbard and Jan Mayen',
    currency: 'NOK',
    symbol: 'Nkr'
  },
  [CountryCode.PY]: {
    countryName: 'Paraguay',
    currency: 'PYG',
    symbol: '₲'
  },
  [CountryCode.IQ]: {
    countryName: 'Iraq',
    currency: 'IQD',
    symbol: 'IQD'
  },
  [CountryCode.PA]: {
    countryName: 'Panama',
    currency: 'PAB',
    symbol: 'B/.'
  },
  [CountryCode.PF]: {
    countryName: 'French Polynesia',
    currency: 'XPF',
    symbol: 'XPF'
  },
  [CountryCode.PG]: {
    countryName: 'Papua New Guinea',
    currency: 'PGK',
    symbol: 'PGK'
  },
  [CountryCode.PE]: {
    countryName: 'Peru',
    currency: 'PEN',
    symbol: 'S/.'
  },
  [CountryCode.PK]: {
    countryName: 'Pakistan',
    currency: 'PKR',
    symbol: 'PKRs'
  },
  [CountryCode.PH]: {
    countryName: 'Philippines',
    currency: 'PHP',
    symbol: '₱'
  },
  [CountryCode.PN]: {
    countryName: 'Pitcairn',
    currency: 'NZD',
    symbol: 'NZ$'
  },
  [CountryCode.PL]: {
    countryName: 'Poland',
    currency: 'PLN',
    symbol: 'zł'
  },
  [CountryCode.PM]: {
    countryName: 'Saint Pierre and Miquelon',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.ZM]: {
    countryName: 'Zambia',
    currency: 'ZMK',
    symbol: 'ZK'
  },
  [CountryCode.EH]: {
    countryName: 'Western Sahara',
    currency: 'MAD',
    symbol: 'MAD'
  },
  [CountryCode.EE]: {
    countryName: 'Estonia',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.EG]: {
    countryName: 'Egypt',
    currency: 'EGP',
    symbol: 'EGP'
  },
  [CountryCode.ZA]: {
    countryName: 'South Africa',
    currency: 'ZAR',
    symbol: 'R'
  },
  [CountryCode.EC]: {
    countryName: 'Ecuador',
    currency: 'USD',
    symbol: '$'
  },
  [CountryCode.IT]: {
    countryName: 'Italy',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.VN]: {
    countryName: 'Vietnam',
    currency: 'VND',
    symbol: '₫'
  },
  [CountryCode.SB]: {
    countryName: 'Solomon Islands',
    currency: 'SBD',
    symbol: 'SBD'
  },
  [CountryCode.ET]: {
    countryName: 'Ethiopia',
    currency: 'ETB',
    symbol: 'Br'
  },
  [CountryCode.SO]: {
    countryName: 'Somalia',
    currency: 'SOS',
    symbol: 'Ssh'
  },
  [CountryCode.ZW]: {
    countryName: 'Zimbabwe',
    currency: 'ZWL',
    symbol: 'ZWL'
  },
  [CountryCode.SA]: {
    countryName: 'Saudi Arabia',
    currency: 'SAR',
    symbol: 'SR'
  },
  [CountryCode.ES]: {
    countryName: 'Spain',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.ER]: {
    countryName: 'Eritrea',
    currency: 'ERN',
    symbol: 'Nfk'
  },
  [CountryCode.ME]: {
    countryName: 'Montenegro',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.MD]: {
    countryName: 'Moldova',
    currency: 'MDL',
    symbol: 'MDL'
  },
  [CountryCode.MG]: {
    countryName: 'Madagascar',
    currency: 'MGA',
    symbol: 'MGA'
  },
  [CountryCode.MF]: {
    countryName: 'Saint Martin',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.MA]: {
    countryName: 'Morocco',
    currency: 'MAD',
    symbol: 'MAD'
  },
  [CountryCode.MC]: {
    countryName: 'Monaco',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.UZ]: {
    countryName: 'Uzbekistan',
    currency: 'UZS',
    symbol: 'UZS'
  },
  [CountryCode.MM]: {
    countryName: 'Myanmar',
    currency: 'MMK',
    symbol: 'MMK'
  },
  [CountryCode.ML]: {
    countryName: 'Mali',
    currency: 'XOF',
    symbol: 'CFA'
  },
  [CountryCode.MO]: {
    countryName: 'Macao',
    currency: 'MOP',
    symbol: 'MOP$'
  },
  [CountryCode.MN]: {
    countryName: 'Mongolia',
    currency: 'MNT',
    symbol: 'MNT'
  },
  [CountryCode.MH]: {
    countryName: 'Marshall Islands',
    currency: 'USD',
    symbol: '$'
  },
  [CountryCode.MK]: {
    countryName: 'Macedonia',
    currency: 'MKD',
    symbol: 'MKD'
  },
  [CountryCode.MU]: {
    countryName: 'Mauritius',
    currency: 'MUR',
    symbol: 'MURs'
  },
  [CountryCode.MT]: {
    countryName: 'Malta',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.MW]: {
    countryName: 'Malawi',
    currency: 'MWK',
    symbol: 'MWK'
  },
  [CountryCode.MV]: {
    countryName: 'Maldives',
    currency: 'MVR',
    symbol: 'MVR'
  },
  [CountryCode.MQ]: {
    countryName: 'Martinique',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.MP]: {
    countryName: 'Northern Mariana Islands',
    currency: 'USD',
    symbol: '$'
  },
  [CountryCode.MS]: {
    countryName: 'Montserrat',
    currency: 'XCD',
    symbol: 'XCD'
  },
  [CountryCode.MR]: {
    countryName: 'Mauritania',
    currency: 'MRO',
    symbol: 'MRO'
  },
  [CountryCode.IM]: {
    countryName: 'Isle of Man',
    currency: 'GBP',
    symbol: '£'
  },
  [CountryCode.UG]: {
    countryName: 'Uganda',
    currency: 'UGX',
    symbol: 'USh'
  },
  [CountryCode.TZ]: {
    countryName: 'Tanzania',
    currency: 'TZS',
    symbol: 'TSh'
  },
  [CountryCode.MY]: {
    countryName: 'Malaysia',
    currency: 'MYR',
    symbol: 'RM'
  },
  [CountryCode.MX]: {
    countryName: 'Mexico',
    currency: 'MXN',
    symbol: 'MX$'
  },
  [CountryCode.IL]: {
    countryName: 'Israel',
    currency: 'ILS',
    symbol: '₪'
  },
  [CountryCode.FR]: {
    countryName: 'France',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.IO]: {
    countryName: 'British Indian Ocean Territory',
    currency: 'USD',
    symbol: '$'
  },
  [CountryCode.SH]: {
    countryName: 'Saint Helena',
    currency: 'SHP',
    symbol: 'SHP'
  },
  [CountryCode.FI]: {
    countryName: 'Finland',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.FJ]: {
    countryName: 'Fiji',
    currency: 'FJD',
    symbol: 'FJD'
  },
  [CountryCode.FK]: {
    countryName: 'Falkland Islands',
    currency: 'FKP',
    symbol: 'FKP'
  },
  [CountryCode.FM]: {
    countryName: 'Micronesia',
    currency: 'USD',
    symbol: '$'
  },
  [CountryCode.FO]: {
    countryName: 'Faroe Islands',
    currency: 'DKK',
    symbol: 'Dkr'
  },
  [CountryCode.NI]: {
    countryName: 'Nicaragua',
    currency: 'NIO',
    symbol: 'C$'
  },
  [CountryCode.NL]: {
    countryName: 'Netherlands',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.NO]: {
    countryName: 'Norway',
    currency: 'NOK',
    symbol: 'Nkr'
  },
  [CountryCode.NA]: {
    countryName: 'Namibia',
    currency: 'NAD',
    symbol: 'N$'
  },
  [CountryCode.VU]: {
    countryName: 'Vanuatu',
    currency: 'VUV',
    symbol: 'VUV'
  },
  [CountryCode.NC]: {
    countryName: 'New Caledonia',
    currency: 'XPF',
    symbol: 'XPF'
  },
  [CountryCode.NE]: {
    countryName: 'Niger',
    currency: 'XOF',
    symbol: 'CFA'
  },
  [CountryCode.NF]: {
    countryName: 'Norfolk Island',
    currency: 'AUD',
    symbol: 'AU$'
  },
  [CountryCode.NG]: {
    countryName: 'Nigeria',
    currency: 'NGN',
    symbol: '₦'
  },
  [CountryCode.NZ]: {
    countryName: 'New Zealand',
    currency: 'NZD',
    symbol: 'NZ$'
  },
  [CountryCode.NP]: {
    countryName: 'Nepal',
    currency: 'NPR',
    symbol: 'NPRs'
  },
  [CountryCode.NR]: {
    countryName: 'Nauru',
    currency: 'AUD',
    symbol: 'AU$'
  },
  [CountryCode.NU]: {
    countryName: 'Niue',
    currency: 'NZD',
    symbol: 'NZ$'
  },
  [CountryCode.CK]: {
    countryName: 'Cook Islands',
    currency: 'NZD',
    symbol: 'NZ$'
  },
  [CountryCode.XK]: {
    countryName: 'Kosovo',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.CI]: {
    countryName: 'Ivory Coast',
    currency: 'XOF',
    symbol: 'CFA'
  },
  [CountryCode.CH]: {
    countryName: 'Switzerland',
    currency: 'CHF',
    symbol: 'CHF'
  },
  [CountryCode.CO]: {
    countryName: 'Colombia',
    currency: 'COP',
    symbol: 'CO$'
  },
  [CountryCode.CN]: {
    countryName: 'China',
    currency: 'CNY',
    symbol: 'CN¥'
  },
  [CountryCode.CM]: {
    countryName: 'Cameroon',
    currency: 'XAF',
    symbol: 'FCFA'
  },
  [CountryCode.CL]: {
    countryName: 'Chile',
    currency: 'CLP',
    symbol: 'CL$'
  },
  [CountryCode.CC]: {
    countryName: 'Cocos Islands',
    currency: 'AUD',
    symbol: 'AU$'
  },
  [CountryCode.CA]: {
    countryName: 'Canada',
    currency: 'CAD',
    symbol: 'CA$'
  },
  [CountryCode.CG]: {
    countryName: 'Republic of the Congo',
    currency: 'XAF',
    symbol: 'FCFA'
  },
  [CountryCode.CF]: {
    countryName: 'Central African Republic',
    currency: 'XAF',
    symbol: 'FCFA'
  },
  [CountryCode.CD]: {
    countryName: 'Democratic Republic of the Congo',
    currency: 'CDF',
    symbol: 'CDF'
  },
  [CountryCode.CZ]: {
    countryName: 'Czech Republic',
    currency: 'CZK',
    symbol: 'Kč'
  },
  [CountryCode.CY]: {
    countryName: 'Cyprus',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.CX]: {
    countryName: 'Christmas Island',
    currency: 'AUD',
    symbol: 'AU$'
  },
  [CountryCode.CR]: {
    countryName: 'Costa Rica',
    currency: 'CRC',
    symbol: '₡'
  },
  [CountryCode.CW]: {
    countryName: 'Curacao',
    currency: 'ANG',
    symbol: 'ANG'
  },
  [CountryCode.CV]: {
    countryName: 'Cape Verde',
    currency: 'CVE',
    symbol: 'CV$'
  },
  [CountryCode.CU]: {
    countryName: 'Cuba',
    currency: 'CUP',
    symbol: 'CUP'
  },
  [CountryCode.SZ]: {
    countryName: 'Swaziland',
    currency: 'SZL',
    symbol: 'SZL'
  },
  [CountryCode.SY]: {
    countryName: 'Syria',
    currency: 'SYP',
    symbol: 'SY£'
  },
  [CountryCode.SX]: {
    countryName: 'Sint Maarten',
    currency: 'ANG',
    symbol: 'ANG'
  },
  [CountryCode.KG]: {
    countryName: 'Kyrgyzstan',
    currency: 'KGS',
    symbol: 'KGS'
  },
  [CountryCode.KE]: {
    countryName: 'Kenya',
    currency: 'KES',
    symbol: 'Ksh'
  },
  [CountryCode.SS]: {
    countryName: 'South Sudan',
    currency: 'SSP',
    symbol: 'SSP'
  },
  [CountryCode.SR]: {
    countryName: 'Suriname',
    currency: 'SRD',
    symbol: 'SRD'
  },
  [CountryCode.KI]: {
    countryName: 'Kiribati',
    currency: 'AUD',
    symbol: 'AU$'
  },
  [CountryCode.KH]: {
    countryName: 'Cambodia',
    currency: 'KHR',
    symbol: 'KHR'
  },
  [CountryCode.KN]: {
    countryName: 'Saint Kitts and Nevis',
    currency: 'XCD',
    symbol: 'XCD'
  },
  [CountryCode.KM]: {
    countryName: 'Comoros',
    currency: 'KMF',
    symbol: 'CF'
  },
  [CountryCode.ST]: {
    countryName: 'Sao Tome and Principe',
    currency: 'STD',
    symbol: 'STD'
  },
  [CountryCode.SK]: {
    countryName: 'Slovakia',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.KR]: {
    countryName: 'South Korea',
    currency: 'KRW',
    symbol: '₩'
  },
  [CountryCode.SI]: {
    countryName: 'Slovenia',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.KP]: {
    countryName: 'North Korea',
    currency: 'KPW',
    symbol: 'KPW'
  },
  [CountryCode.KW]: {
    countryName: 'Kuwait',
    currency: 'KWD',
    symbol: 'KD'
  },
  [CountryCode.SN]: {
    countryName: 'Senegal',
    currency: 'XOF',
    symbol: 'CFA'
  },
  [CountryCode.SM]: {
    countryName: 'San Marino',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.SL]: {
    countryName: 'Sierra Leone',
    currency: 'SLL',
    symbol: 'SLL'
  },
  [CountryCode.SC]: {
    countryName: 'Seychelles',
    currency: 'SCR',
    symbol: 'SCR'
  },
  [CountryCode.KZ]: {
    countryName: 'Kazakhstan',
    currency: 'KZT',
    symbol: 'KZT'
  },
  [CountryCode.KY]: {
    countryName: 'Cayman Islands',
    currency: 'KYD',
    symbol: 'KYD'
  },
  [CountryCode.SG]: {
    countryName: 'Singapore',
    currency: 'SGD',
    symbol: 'S$'
  },
  [CountryCode.SE]: {
    countryName: 'Sweden',
    currency: 'SEK',
    symbol: 'Skr'
  },
  [CountryCode.SD]: {
    countryName: 'Sudan',
    currency: 'SDG',
    symbol: 'SDG'
  },
  [CountryCode.DO]: {
    countryName: 'Dominican Republic',
    currency: 'DOP',
    symbol: 'RD$'
  },
  [CountryCode.DM]: {
    countryName: 'Dominica',
    currency: 'XCD',
    symbol: 'XCD'
  },
  [CountryCode.DJ]: {
    countryName: 'Djibouti',
    currency: 'DJF',
    symbol: 'Fdj'
  },
  [CountryCode.DK]: {
    countryName: 'Denmark',
    currency: 'DKK',
    symbol: 'Dkr'
  },
  [CountryCode.VG]: {
    countryName: 'British Virgin Islands',
    currency: 'USD',
    symbol: '$'
  },
  [CountryCode.DE]: {
    countryName: 'Germany',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.YE]: {
    countryName: 'Yemen',
    currency: 'YER',
    symbol: 'YR'
  },
  [CountryCode.DZ]: {
    countryName: 'Algeria',
    currency: 'DZD',
    symbol: 'DA'
  },
  [CountryCode.US]: {
    countryName: 'United States',
    currency: 'USD',
    symbol: '$'
  },
  [CountryCode.UY]: {
    countryName: 'Uruguay',
    currency: 'UYU',
    symbol: '$U'
  },
  [CountryCode.YT]: {
    countryName: 'Mayotte',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.UM]: {
    countryName: 'United States Minor Outlying Islands',
    currency: 'USD',
    symbol: '$'
  },
  [CountryCode.LB]: {
    countryName: 'Lebanon',
    currency: 'LBP',
    symbol: 'LB£'
  },
  [CountryCode.LC]: {
    countryName: 'Saint Lucia',
    currency: 'XCD',
    symbol: 'XCD'
  },
  [CountryCode.LA]: {
    countryName: 'Laos',
    currency: 'LAK',
    symbol: 'LAK'
  },
  [CountryCode.TV]: {
    countryName: 'Tuvalu',
    currency: 'AUD',
    symbol: 'AU$'
  },
  [CountryCode.TW]: {
    countryName: 'Taiwan',
    currency: 'TWD',
    symbol: 'NT$'
  },
  [CountryCode.TT]: {
    countryName: 'Trinidad and Tobago',
    currency: 'TTD',
    symbol: 'TT$'
  },
  [CountryCode.TR]: {
    countryName: 'Turkey',
    currency: 'TRY',
    symbol: 'TL'
  },
  [CountryCode.LK]: {
    countryName: 'Sri Lanka',
    currency: 'LKR',
    symbol: 'SLRs'
  },
  [CountryCode.LI]: {
    countryName: 'Liechtenstein',
    currency: 'CHF',
    symbol: 'CHF'
  },
  [CountryCode.LV]: {
    countryName: 'Latvia',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.TO]: {
    countryName: 'Tonga',
    currency: 'TOP',
    symbol: 'T$'
  },
  [CountryCode.LT]: {
    countryName: 'Lithuania',
    currency: 'LTL',
    symbol: 'Lt'
  },
  [CountryCode.LU]: {
    countryName: 'Luxembourg',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.LR]: {
    countryName: 'Liberia',
    currency: 'LRD',
    symbol: 'LRD'
  },
  [CountryCode.LS]: {
    countryName: 'Lesotho',
    currency: 'LSL',
    symbol: 'LSL'
  },
  [CountryCode.TH]: {
    countryName: 'Thailand',
    currency: 'THB',
    symbol: '฿'
  },
  [CountryCode.TF]: {
    countryName: 'French Southern Territories',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.TG]: {
    countryName: 'Togo',
    currency: 'XOF',
    symbol: 'CFA'
  },
  [CountryCode.TD]: {
    countryName: 'Chad',
    currency: 'XAF',
    symbol: 'FCFA'
  },
  [CountryCode.TC]: {
    countryName: 'Turks and Caicos Islands',
    currency: 'USD',
    symbol: '$'
  },
  [CountryCode.LY]: {
    countryName: 'Libya',
    currency: 'LYD',
    symbol: 'LD'
  },
  [CountryCode.VA]: {
    countryName: 'Vatican',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.VC]: {
    countryName: 'Saint Vincent and the Grenadines',
    currency: 'XCD',
    symbol: 'XCD'
  },
  [CountryCode.AE]: {
    countryName: 'United Arab Emirates',
    currency: 'AED',
    symbol: 'AED'
  },
  [CountryCode.AD]: {
    countryName: 'Andorra',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.AG]: {
    countryName: 'Antigua and Barbuda',
    currency: 'XCD',
    symbol: 'XCD'
  },
  [CountryCode.AF]: {
    countryName: 'Afghanistan',
    currency: 'AFN',
    symbol: 'Af'
  },
  [CountryCode.AI]: {
    countryName: 'Anguilla',
    currency: 'XCD',
    symbol: 'XCD'
  },
  [CountryCode.VI]: {
    countryName: 'U.S. Virgin Islands',
    currency: 'USD',
    symbol: '$'
  },
  [CountryCode.IS]: {
    countryName: 'Iceland',
    currency: 'ISK',
    symbol: 'Ikr'
  },
  [CountryCode.IR]: {
    countryName: 'Iran',
    currency: 'IRR',
    symbol: 'IRR'
  },
  [CountryCode.AM]: {
    countryName: 'Armenia',
    currency: 'AMD',
    symbol: 'AMD'
  },
  [CountryCode.AL]: {
    countryName: 'Albania',
    currency: 'ALL',
    symbol: 'ALL'
  },
  [CountryCode.AO]: {
    countryName: 'Angola',
    currency: 'AOA',
    symbol: 'AOA'
  },
  [CountryCode.AQ]: {
    countryName: 'Antarctica',
    currency: '',
    symbol: ''
  },
  [CountryCode.AS]: {
    countryName: 'American Samoa',
    currency: 'USD',
    symbol: '$'
  },
  [CountryCode.AR]: {
    countryName: 'Argentina',
    currency: 'ARS',
    symbol: 'AR$'
  },
  [CountryCode.AU]: {
    countryName: 'Australia',
    currency: 'AUD',
    symbol: 'AU$'
  },
  [CountryCode.AT]: {
    countryName: 'Austria',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.AW]: {
    countryName: 'Aruba',
    currency: 'AWG',
    symbol: 'AWG'
  },
  [CountryCode.IN]: {
    countryName: 'India',
    currency: 'INR',
    symbol: 'Rs'
  },
  [CountryCode.AX]: {
    countryName: 'Aland Islands',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.AZ]: {
    countryName: 'Azerbaijan',
    currency: 'AZN',
    symbol: 'man.'
  },
  [CountryCode.IE]: {
    countryName: 'Ireland',
    currency: 'EUR',
    symbol: '€'
  },
  [CountryCode.ID]: {
    countryName: 'Indonesia',
    currency: 'IDR',
    symbol: 'Rp'
  },
  [CountryCode.UA]: {
    countryName: 'Ukraine',
    currency: 'UAH',
    symbol: '₴'
  },
  [CountryCode.QA]: {
    countryName: 'Qatar',
    currency: 'QAR',
    symbol: 'QR'
  },
  [CountryCode.MZ]: {
    countryName: 'Mozambique',
    currency: 'MZN',
    symbol: 'MTn'
  },
  [CountryCode.ZZ]: {
    countryName: 'unknown',
    currency: '',
    symbol: ''
  }
}

export default currencyData
